import React, { useState, useEffect, useContext, useRef } from "react";
import MainButton from "../Props/MainButton";
import Loader from "../Props/Loader";
import AccountsAndGroupsSynchronization from "./AccountsAndGroupsSynchronization";
import ProductsAndGroupsSynchronization from "./ProductsAndGroupsSynchronization";
import SettingsSynchronization from "./SettingsSynchronization";
import MyContext from "../MyContext";
import Company from "../../API/APIServices/Company";

function SynchronizeMasterAndSetting() {
  useEffect(() => {
    document.title = "Synchronize Masters And Settings";
  }, []);

  const { UserDetails } = useContext(MyContext);

  const dropDownRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(1);

  const [currentFirmId, setCurrentFirmId] = useState(0);
  const [currentFirmName, setCurrentFirmName] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [isDestinationShow, setIsDestinationShow] = useState(false);

  useEffect(() => {
    if (UserDetails) {
    

      const currentBranchId = UserDetails.branchId;
      const findData = companyList.find((item) => item.id == currentBranchId);
      if (findData !== undefined) {
        setCurrentFirmName(findData.name);
      }

      setCurrentFirmId(currentBranchId);

      const tempCompanyList = companyList.filter(
        (item) => item.id !== currentBranchId
      );
      setCompanyList(tempCompanyList);
    }
  }, [UserDetails]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = await Company.GetCompany();

        if (data) {
          data = data.map((item) => {
            item.isSelected = false;
            return item;
          });

          const currentBranchId = UserDetails ? UserDetails.branchId : 0;

          data = data.filter((item) => item.id != currentBranchId);

          const findData = data.find((item) => item.id == currentBranchId);

          
          if (findData !== undefined) {
            setCurrentFirmName(findData.name);
            setCurrentFirmId(currentBranchId);
          }

          setCompanyList(data);
        }
      } catch (error) {
        console.log("Error when fetching company list", error);
      }
    };

    fetchData();
  }, []);

  function toggleDestinationShow() {
    setIsDestinationShow(!isDestinationShow);
  }

  function handleDestinationFirmSelect(e, index) {
    const checked = e.target.checked;

    const tempCompanyList = [...companyList];

    tempCompanyList[index].isSelected = checked;

    setCompanyList(tempCompanyList);
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropDownRef.current) {
        console.log(event.target);
        console.log(!dropDownRef.current.contains(event.target));
      }

      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setIsDestinationShow(false);
      }
    }

    // document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div style={{ zIndex: 10 }} className="panel-heading">
        <div className="panel-head-title">
          <h2 className="panel-title">Synchronize Masters And Settings</h2>
        </div>

        {/* *******************Top Buttons****************** */}

        <MainButton saveButtonHide={true} />
      </div>

      <div className="content_box">
        <div
          onClick={() => setIsDestinationShow(false)}
          className="company-info-top-im"
        >
          <div className="tab-head">
            <div id="tabs">
              <div className="tab-btn-box">
                <div
                  onClick={() => setTab(1)}
                  className={`tab  ${tab === 1 ? "active" : ""}`}
                >
                  Products And Groups
                </div>

                <div
                  onClick={() => setTab(2)}
                  className={`tab  ${tab === 2 ? "active" : ""}`}
                >
                  Account And Groups
                </div>

                <div
                  onClick={() => setTab(3)}
                  className={`tab  ${tab === 3 ? "active" : ""}`}
                >
                  Settings
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="padding-20">
          <div className="HeadContentInputBpx" style={{ alignItems: "center" }}>
            <div className="input-box-m11">
              <select
                value={currentFirmId}
                className="modify_im_input mode_category"
                type="text"
                required
              >
                <option value={currentFirmId}>{currentFirmName}</option>
              </select>
              <label class="ItemMasterLabelFix">Current Firm</label>
            </div>

            <div className="input-box-m11">
              <div
                ref={dropDownRef}
                style={{
                  border: "1px solid #CCCCCC",
                  borderRadius: "4px",
                  zIndex: 5,
                }}
                className="customize-delete-custome-select-option relative"
              >
                <div
                  onClick={toggleDestinationShow}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointe",
                  }}
                >
                  <div>Destination Firm</div>
                  <i
                    class={`fa-solid fa-circle-chevron-down arrow ${
                      isDestinationShow ? "rotated" : ""
                    }`}
                  ></i>
                </div>

                {isDestinationShow && (
                  <div className="customize-delete-custome-select-box">
                    {companyList.map((item, index) => (
                      <div
                        className="customize-delete-custome-select-option"
                        key={index}
                      >
                        <div className="customize-delete-custome-select-option-div">
                          {item.name}
                        </div>
                        <input
                          className="customize-delete-custome-select-option-input"
                          type="checkbox"
                          onChange={(e) =>
                            handleDestinationFirmSelect(e, index)
                          }
                          checked={item.isSelected}
                          value={item.id}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {tab == 1 && (
            <ProductsAndGroupsSynchronization
              setLoading={setLoading}
              setIsDestinationShow={setIsDestinationShow}
              currentFirmId={currentFirmId}
              companyList={companyList}
            />
          )}

          {tab == 2 && (
            <AccountsAndGroupsSynchronization
              setLoading={setLoading}
              setIsDestinationShow={setIsDestinationShow}
              currentFirmId={currentFirmId}
              companyList={companyList}
            />
          )}

          {tab == 3 && <SettingsSynchronization setLoading={setLoading} />}
        </div>

        <div>
          <div className="buttom-box">
            <div className="button-btn-2">
              <button
                className="btn-2"
                onClick={() => window.location.reload()}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </div>
  );
}

export default SynchronizeMasterAndSetting;
